/**
 * Brand Carousel
 *
 * This component requires jQuery and Slick to function.
 * You can require it on the page using <div data-component="brand-slider"></div>
 */

 import 'slick-carousel';

 $( function () {
     $( '[data-component="p2-brand-slider"]' ).each( function () {
         let $holder = $( this );
 
         $holder.slick(
             {
                 rows: 2,
                 speed: 5000,
                 pauseOnHover: false,
                 autoplay: true,
                 autoplaySpeed: 0,
                 cssEase: 'linear',
                 infinite: true,
                 arrows: false,
                 slidesToShow: 1,
                 slidesToScroll: 1,
                 initialSlide: 1,
                 variableWidth: true,
                 responsive: [ {
                     breakpoint: 768,
                     settings: {
                         rows: 2,
                     },
                 } ],
             }
         );
     } );
 } );
 